import { createContext } from "react";
/**
 * Context for injecting a different set of components for rendering controls
 *
 * Examples for controls
 * - radio
 * - select
 */
export const ControlComponentContext = createContext({});
ControlComponentContext.displayName = "ControlComponentContext";
//# sourceMappingURL=ControlComponentContext.js.map